import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import FeatureTableHeaderCell from './FeatureTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const THead = styled.thead.withConfig({
  displayName: "FeatureTableHead__THead",
  componentId: "sc-1y38ix9-0"
})(({
  theme
}) => {
  return {
    width: '100%',
    display: 'table',
    height: '155px',
    position: 'sticky',
    top: '-1px',
    zIndex: 1,
    // trellis doesn't have support for MERCURY_LAYER yet
    background: theme.color['fill-surface-default'],
    paddingBottom: theme.space['400'],
    tableLayout: 'fixed',
    verticalAlign: 'bottom'
  };
});
const FeatureTableHead = ({
  headerData
}) => {
  const apiNames = Object.keys(headerData);
  return /*#__PURE__*/_jsx(THead, {
    "data-test-id": "feature-table-head",
    children: /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsx("th", {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          typography: "heading-600",
          marginBlockEnd: "0",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.featureTable.tableHeader.features"
          })
        })
      }), apiNames.map(apiName => {
        const headerCellData = headerData[apiName];
        if (!headerCellData) {
          /* eslint-disable-next-line react/jsx-key */
          return /*#__PURE__*/_jsx("th", {});
        }
        const {
          Content
        } = headerCellData;
        return /*#__PURE__*/_jsx(FeatureTableHeaderCell, {
          apiName: apiName,
          Content: Content
        }, apiName);
      })]
    })
  });
};
export default FeatureTableHead;